(function() {
  if (customElements.get('scrollable-banners')) return;

  class ScrollableBanners extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.container = this.querySelector('.ai-scrollable-banners__container');
      this.prevButton = this.querySelector('.ai-scrollable-banners__arrow--prev');
      this.nextButton = this.querySelector('.ai-scrollable-banners__arrow--next');
      if (!this.container) return;

      if (!this._sbBound) {
        this.setupTouchScroll();
        this.setupArrows();
        this.setupPaginator();
        this._sbBound = true;
      }
      this.armExternalObservation();
      if (this.prevButton && this.nextButton) this.updateArrowState();
    }

    disconnectedCallback() {
      if (this._sbResizeHandler) window.removeEventListener('resize', this._sbResizeHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    setupTouchScroll() {
      if (!this.container) return;

      let isDown = false;
      let startX;
      let scrollLeft;
      let dragMoved = false;

      this.container.addEventListener('mousedown', (e) => {
        isDown = true;
        dragMoved = false;
        this.container.style.cursor = 'grabbing';
        startX = e.pageX - this.container.offsetLeft;
        scrollLeft = this.container.scrollLeft;
      });

      this.container.addEventListener('mouseleave', () => {
        isDown = false;
        this.container.style.cursor = 'grab';
      });

      this.container.addEventListener('mouseup', () => {
        isDown = false;
        this.container.style.cursor = 'grab';
      });

      this.container.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.container.offsetLeft;
        const walk = (x - startX) * 2;
        if (Math.abs(x - startX) > 4) dragMoved = true;
        this.container.scrollLeft = scrollLeft - walk;
      });

      // Suppress the click that follows a drag so grabbing to scroll never
      // navigates a banner link.
      this.container.addEventListener('click', (e) => {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          dragMoved = false;
        }
      }, true);

      this.container.style.cursor = 'grab';
    }

    setupArrows() {
      if (!this.container || !this.prevButton || !this.nextButton) return;

      this.prevButton.addEventListener('click', () => this.scrollByOneBanner(-1));
      this.nextButton.addEventListener('click', () => this.scrollByOneBanner(1));

      this.container.addEventListener('scroll', () => this.updateArrowState());

      this._sbResizeHandler = () => this.updateArrowState();
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.updateArrowState());
      }
    }

    armExternalObservation() {
      if (!this.container) return;
      if (this.resizeObserver) this.resizeObserver.observe(this.container);
      else if (this._sbResizeHandler) window.addEventListener('resize', this._sbResizeHandler);
    }

    scrollByOneBanner(direction) {
      const firstBanner = this.container.querySelector('.ai-scrollable-banners__banner');
      if (!firstBanner) return;
      const gap = parseFloat(window.getComputedStyle(this.container).gap) || 0;
      const scrollAmount = (firstBanner.offsetWidth + gap) * direction;
      this.container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    updateArrowState() {
      const noOverflow = this.container.scrollWidth <= this.container.clientWidth + 1;
      if (noOverflow) {
        this.prevButton.disabled = true;
        this.nextButton.disabled = true;
        return;
      }
      const atStart = this.container.scrollLeft <= 1;
      const atEnd = this.container.scrollLeft >= (this.container.scrollWidth - this.container.clientWidth - 1);
      this.prevButton.disabled = atStart;
      this.nextButton.disabled = atEnd;
    }

    setupPaginator() {
      this.dots = Array.from(this.querySelectorAll('.ai-scrollable-banners__dot'));
      if (this.dots.length === 0) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.targetIndex, 10);
          if (!isNaN(index)) this.scrollToBanner(index);
        });
      });

      let rafId = null;
      this.container.addEventListener('scroll', () => {
        if (rafId !== null) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          rafId = null;
          this.updateActiveDot();
        });
      });

      this.updateActiveDot();
    }

    updateActiveDot() {
      if (!this.dots || this.dots.length === 0) return;
      const firstBanner = this.container.querySelector('.ai-scrollable-banners__banner');
      if (!firstBanner) return;
      const gap = parseFloat(window.getComputedStyle(this.container).gap) || 0;
      const stride = firstBanner.offsetWidth + gap;
      if (stride <= 0) return;
      const index = Math.round(this.container.scrollLeft / stride);
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    scrollToBanner(index) {
      const firstBanner = this.container.querySelector('.ai-scrollable-banners__banner');
      if (!firstBanner) return;
      const gap = parseFloat(window.getComputedStyle(this.container).gap) || 0;
      const targetScroll = index * (firstBanner.offsetWidth + gap);
      this.container.scrollTo({ left: targetScroll, behavior: 'smooth' });
    }
  }

  customElements.define('scrollable-banners', ScrollableBanners);
})();
